import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import { ProxyCookieAuth } from './ProxyCookieAuth';

export const proxyAuthModule = createFrontendModule({
  pluginId: 'app',

  extensions: [
    AppRootWrapperBlueprint.make({
      name: 'proxy-cookie-auth',
      params: {
        component: ProxyCookieAuth,
      },
    }),
  ],
});
